const name = 'clients';

export const UPDATE_CLIENT_REQUEST = `${name}/UPDATE_CLIENT_REQUEST`;
export const UPDATE_CLIENT_SUCCESS = `${name}/UPDATE_CLIENT_SUCCESS`;
export const UPDATE_CLIENT_FAILURE = `${name}/UPDATE_CLIENT_FAILURE`;

export const ADD_CLIENT_PHONE_REQUEST = `${name}/ADD_CLIENT_PHONE_REQUEST`;
export const ADD_CLIENT_PHONE_SUCCESS = `${name}/ADD_CLIENT_PHONE_SUCCESS`;
export const ADD_CLIENT_PHONE_FAILURE = `${name}/ADD_CLIENT_PHONE_FAILURE`;

export const DELETE_CLIENT_PHONE_REQUEST = `${name}/DELETE_CLIENT_PHONE_REQUEST`;
export const DELETE_CLIENT_PHONE_SUCCESS = `${name}/DELETE_CLIENT_PHONE_SUCCESS`;
export const DELETE_CLIENT_PHONE_FAILURE = `${name}/DELETE_CLIENT_PHONE_FAILURE`;

export const FIND_CLIENTS_REQUEST = `${name}/FIND_CLIENTS_REQUEST`;
export const FIND_CLIENTS_SUCCESS = `${name}/FIND_CLIENTS_SUCCESS`;
export const FIND_CLIENTS_FAILURE = `${name}/FIND_CLIENTS_FAILURE`;

export const FIND_CLIENT_DELIVERY_DETAILS_REQUEST = `${name}/FIND_CLIENT_DELIVERY_DETAILS_REQUEST`;
export const FIND_CLIENT_DELIVERY_DETAILS_SUCCESS = `${name}/FIND_CLIENT_DELIVERY_DETAILS_SUCCESS`;
export const FIND_CLIENT_DELIVERY_DETAILS_FAILURE = `${name}/FIND_CLIENT_DELIVERY_DETAILS_FAILURE`;

export default name;
